import { inject, observer } from 'mobx-react';
import React from 'react';

import SingleButton from '@/components/SingleButton';
import { getTrans, handleClickHistoryButton } from '@/utils/tools';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { getEnquiryInfo } from '@/utils/btnClickHandler';
import { isFood } from '@/utils/saas';
import './style.scss';

const PREFIX = 'enquiry-details-container';

@inject(getChildInject('agentStore', 'initStore'))
@observer
export default class EnquiryDetails extends React.PureComponent {
  static defaultProps = {
    // props
    dialogueId: '',
    dialogueType: '',
    isDisabled: false,
    // stores
    agentStore: {},
  };

  handleClick = () => {
    const {
      isHistory,
      clickParams,
    } = this.props;
    // this.trackingHandler();
    if (isHistory) {
      handleClickHistoryButton();
      return;
    }
    getEnquiryInfo(...clickParams);
    // this.props?.onClick?.();
  };

  render() {
    const {
      agentStore,
      isDisabled,
      disabledBtn,
      title,
      content,
      footer,
    } = this.props;

    const { loadingInAgent, inAgent } = agentStore;

    return <div
      className={PREFIX}
    >
      <div className="msg">
        <div className="msg-title msg-title-content">{title || getTrans(isFood() ? 'shopee_foodVN_enquiry_details_title' : 'enquiry_details_title')}</div>
        <div className="msg-desc">{content || getTrans('enquiry_details_desc')}</div>
      </div>
      {
        loadingInAgent || inAgent || isDisabled
          ? null
          : <SingleButton
            disabled={disabledBtn}
            text={footer || getTrans('enquiry_details_btn')}
            handleClick={this.handleClick}
          />
      }
    </div>;
  }
}
